/**
 * Maps locale code to language format (BCP 47)
 * @param locale - Locale code (en, ru, fr, es, de, ja)
 * @returns Language code in format xx-XX (e.g., en-US, ru-RU, ja)
 */
export function getLocaleLanguage(locale: string): string {
  const localeMap: Record<string, string> = {
    en: 'en-US',
    ru: 'ru-RU',
    fr: 'fr',
    es: 'es',
    de: 'de',
    ja: 'ja',
  };

  return localeMap[locale] || 'en-US';
}

export function getOgLocale(locale: string): string {
  return getLocaleLanguage(locale).replace('-', '_');
}

